import React from 'react';
import { Icon } from './Icon.js';
export const IconSearchProperty = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M21 21L16.5 16.5L16.7806 16.7806", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("circle", { cx: "11", cy: "11", r: "8", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M11 7L7 9.625V10.0015H8V14H14V10L15 10.0015V9.625L11 7Z", stroke: "currentColor", strokeWidth: "2", fill: "none" })));
};
//# sourceMappingURL=IconSearchProperty.js.map